<template>
  <div>
    <div class="tw-mb-2">
      <legend>
        {{ $t('Select your business entity type') }}
      </legend>
      <WdsRadioGroup v-model:checked="internalModelValue" name="business_entity">
        <WdsRadio :disabled="disabled" value="ie_limited">
          <i class="input-helper"></i>
          {{ $t('Private Limited Company (LTD)') }}
          <br />
          <span class="c-gray small">
            {{
              $t(
                'If you have a Private Limited Company registered with the Company Registration Office.',
              )
            }}
          </span>
        </WdsRadio>

        <WdsRadio :disabled="disabled" value="ie_sole_trader">
          <i class="input-helper"></i>
          {{ $t('Registered Sole Trader') }}
          <br />
          <span class="c-gray small">
            {{ $t('If you have a Sole Trader business setup with the Revenue.') }}
          </span>
        </WdsRadio>
      </WdsRadioGroup>
    </div>
  </div>
</template>

<script>
import { WdsRadio, WdsRadioGroup } from '@worksome/wds-components'
import { computed } from 'vue'

export default {
  components: {
    WdsRadio,
    WdsRadioGroup,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: String,
      required: true,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const internalModelValue = computed({
      get() {
        return props.modelValue
      },
      set(modelValue) {
        emit('update:modelValue', modelValue)
      },
    })
    return {
      internalModelValue,
    }
  },
}
</script>
